import { addDoc, collection, getFirestore, serverTimestamp } from 'firebase/firestore'

export const logBusinessEvent = async (businessId: string, message: string) =>
  addDoc(collection(getFirestore(), 'business', businessId, 'logs'), {
    time: serverTimestamp(),
    message,
  })
